var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Aries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aries",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,2 C4.239,2 2,4.239 2,7 L4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7 L12,7 C12,4.239 9.761,2 7,2",
    id: "Horn",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,2 C14.239,2 12,4.239 12,7 L14,7 C14,5.343 15.343,4 17,4 C18.657,4 20,5.343 20,7 L22,7 C22,4.239 19.761,2 17,2",
    id: "Horn",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Head",
    fill: "#000000",
    points: "13 22 11 22 10 9 14 9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAries);
export default __webpack_public_path__ + "static/media/aries.bc7c4ede047ff523a53816e3f9a13b00.svg";
export { ForwardRef as ReactComponent };